/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()
// =======================================
// Chic Quilter — Hard Kill Appstle Price Injection
// =======================================

(function () {

  function removeInjectedSubscriptionPrice() {
    document
      .querySelectorAll('.appstle_subscription_final_price')
      .forEach(el => el.remove());

    document
      .querySelectorAll('[style*="rgb(255, 0, 0)"]')
      .forEach(el => {
        el.style.color = 'inherit';
        el.style.border = 'none';
      });
  }

  // Run once after load
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(removeInjectedSubscriptionPrice, 500);
  });

  // 🔑 Run every time Appstle updates
  window.addEventListener('appstle:subscription:updated', () => {
    setTimeout(removeInjectedSubscriptionPrice, 0);
  });

  // Backup observer (belt + suspenders)
  const observer = new MutationObserver(removeInjectedSubscriptionPrice);
  observer.observe(document.body, { childList: true, subtree: true });

})();
/* ======================================
   Chic Quilter — Kill injected SALE junk
   (preserve Subscribe & Save option)
   ====================================== */

(function () {
  const killBadges = () => {
    document.querySelectorAll(
      '.price__badge, .badge--sale, .badge-sale, .product-price__save, .price__save, .price__badge-sale'
    ).forEach(el => el.remove());

    // Kill inline red-styled elements ONLY (not labels)
    document.querySelectorAll('[style*="rgb(255, 0, 0)"]').forEach(el => {
      if (!el.closest('.appstle-selling-plan-label')) {
        el.remove();
      }
    });
  };

  killBadges();

  const observer = new MutationObserver(() => killBadges());
  observer.observe(document.body, { childList: true, subtree: true });
})();
